import { Flex } from "@mantine/core"
import CommentsMenu360 from "../../../../Customer360V2/components/drawer/sideBar360/CommentsMenu360"

const CustomerActions = ({chosenEvidence}:{chosenEvidence: any}) => {

  
  return (

    <Flex
      justify="space-between"
      px="35px"
      pb="20px"
      h="64px"
      sx={{ borderBottom: "1px solid #D8D8DB" }}
      align="center"
    >
      
      <CommentsMenu360 chosenEvidence={chosenEvidence}/>
    </Flex>
  )
}

export default CustomerActions